(function() {
  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function ceilToPack(value, packSize) {
    var size = Math.max(1, Number(packSize) || 1);
    return Math.ceil((Number(value) || 0) / size);
  }

  function moneyFormatter(currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
        maximumFractionDigits: 0
      });
    } catch (error) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      });
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase().trim();
  }

  function rankCandidates(roleConfig) {
    var seen = {};
    var candidates = [];

    if (roleConfig.product) {
      candidates.push(roleConfig.product);
    }

    (roleConfig.fallback || []).forEach(function(item) {
      if (item) candidates.push(item);
    });

    candidates = candidates.filter(function(item) {
      if (!item || !item.variantId) return false;
      if (seen[item.variantId]) return false;
      seen[item.variantId] = true;
      return true;
    });

    return candidates.sort(function(a, b) {
      var aAvailable = a.available ? 1 : 0;
      var bAvailable = b.available ? 1 : 0;
      if (aAvailable !== bAvailable) return bAvailable - aAvailable;

      var aScore = scoreCandidate(a, roleConfig);
      var bScore = scoreCandidate(b, roleConfig);
      if (aScore !== bScore) return bScore - aScore;

      return (a.priceCents || 0) - (b.priceCents || 0);
    });
  }

  function scoreCandidate(product, roleConfig) {
    var haystack = [
      normalizeText(product.title),
      normalizeText(product.vendor),
      normalizeText(product.type),
      Array.isArray(product.tags) ? product.tags.map(normalizeText).join(' ') : ''
    ].join(' ');
    var score = 0;
    (roleConfig.typeHints || []).forEach(function(hint) {
      if (haystack.indexOf(normalizeText(hint)) !== -1) score += 2;
    });
    (roleConfig.tagHints || []).forEach(function(hint) {
      if (haystack.indexOf(normalizeText(hint)) !== -1) score += 1;
    });
    return score;
  }

  function chooseCandidate(roleConfig) {
    var ranked = rankCandidates(roleConfig);
    var selected = ranked[0] || null;
    var available = ranked.filter(function(item) { return item.available; });
    var pricePool = available.length ? available : ranked;
    var minPrice = 0;
    var maxPrice = 0;

    if (pricePool.length) {
      minPrice = pricePool.reduce(function(low, item) {
        return Math.min(low, Number(item.priceCents || 0));
      }, Number(pricePool[0].priceCents || 0));
      maxPrice = pricePool.reduce(function(high, item) {
        return Math.max(high, Number(item.priceCents || 0));
      }, Number(pricePool[0].priceCents || 0));
    }

    return {
      selected: selected,
      minPrice: minPrice,
      maxPrice: maxPrice,
      usedFallback: !!(selected && roleConfig.product && Number(selected.variantId) !== Number(roleConfig.product.variantId)),
      choices: ranked.map(function(product) {
        return {
          product: product,
          usedFallback: !!(roleConfig.product && Number(product.variantId) !== Number(roleConfig.product.variantId))
        };
      })
    };
  }

  function productMeta(product) {
    var parts = [];
    if (product.volume) parts.push(product.volume);
    if (product.abv) parts.push(product.abv + '%');
    return parts.join(' - ');
  }

  function defaultServingKeyForRole(roleKey) {
    var map = {
      houseBeer: 'beerCase',
      premiumBeer: 'beerCase',
      redWine: 'wineBottle',
      whiteWine: 'wineBottle',
      sparkling: 'sparklingBottle',
      vodka: 'spiritBottle',
      rum: 'spiritBottle',
      gin: 'spiritBottle',
      whisky: 'spiritBottle',
      tequila: 'spiritBottle',
      cooler: 'coolerPack',
      rtd: 'rtdPack',
      mixer: 'mixerPack',
      nonAlcoholic: 'nonAlcoholicPack'
    };
    return map[roleKey] || null;
  }

  function parseSizeSpec(value) {
    var normalized = normalizeText(value).replace(/\s+/g, '');
    if (!normalized) {
      return null;
    }

    var multiVolumeMatch = normalized.match(/^(\d+)[x*](\d+(?:\.\d+)?)(ml|l)[a-z]*$/i);
    if (multiVolumeMatch) {
      var packCount = toInt(multiVolumeMatch[1], 0);
      var eachVolume = toNumber(multiVolumeMatch[2], 0);
      var unit = multiVolumeMatch[3].toLowerCase();
      var eachMl = unit === 'l' ? eachVolume * 1000 : eachVolume;
      return {
        packCount: packCount,
        eachMl: eachMl,
        totalMl: packCount * eachMl,
        format: 'multi-volume'
      };
    }

    var packOnlyMatch = normalized.match(/^(\d+)(cans?|bottles?|pack)$/i);
    if (packOnlyMatch) {
      return {
        packCount: toInt(packOnlyMatch[1], 0),
        eachMl: 0,
        totalMl: 0,
        format: 'count-only'
      };
    }

    var volumeMatch = normalized.match(/^(\d+(?:\.\d+)?)(ml|l)[a-z]*$/i);
    if (volumeMatch) {
      var volume = toNumber(volumeMatch[1], 0);
      return {
        packCount: 1,
        eachMl: volumeMatch[2].toLowerCase() === 'l' ? volume * 1000 : volume,
        totalMl: volumeMatch[2].toLowerCase() === 'l' ? volume * 1000 : volume,
        format: 'single-volume'
      };
    }

    var textCountMatch = normalizeText(value).match(/(\d+)\s*(cans?|bottles?|pack)/i);
    if (textCountMatch) {
      return {
        packCount: toInt(textCountMatch[1], 0),
        eachMl: 0,
        totalMl: 0,
        format: 'text-count'
      };
    }

    return null;
  }

  function servingSizeForProduct(product, roleKey, config) {
    var servings = config && config.assumptions ? (config.assumptions.servings || {}) : {};
    var plannerServings = toNumber(product && product.plannerServings, 0);
    if (plannerServings > 0) {
      return plannerServings;
    }

    var packSize = toNumber(product && product.packSize, 0);
    if (packSize > 0) {
      return packSize;
    }

    var parsedSize = parseSizeSpec(product && (product.size || product.volume));
    if (parsedSize) {
      var servingKey = defaultServingKeyForRole(roleKey);

      if (servingKey === 'spiritBottle') {
        if (parsedSize.totalMl > 0) {
          return Math.max(1, Math.round(parsedSize.totalMl / 44));
        }
      } else if (servingKey === 'wineBottle') {
        if (parsedSize.totalMl > 0) {
          return Math.max(1, Math.round(parsedSize.totalMl / 150));
        }
      } else if (servingKey === 'sparklingBottle') {
        if (parsedSize.totalMl > 0) {
          return Math.max(1, Math.round(parsedSize.totalMl / 125));
        }
      } else if (servingKey === 'beerCase' || servingKey === 'coolerPack' || servingKey === 'rtdPack' || servingKey === 'mixerPack' || servingKey === 'nonAlcoholicPack') {
        if (parsedSize.packCount > 1) {
          return parsedSize.packCount;
        }
        if (parsedSize.totalMl >= 600) {
          return Math.max(1, Math.round(parsedSize.totalMl / 355));
        }
        return 1;
      }
    }

    var containerMl = toNumber(product && product.containerMl, 0);
    if (containerMl > 0 && defaultServingKeyForRole(roleKey) === 'spiritBottle') {
      return Math.max(1, Math.round(containerMl / 44));
    }

    var servingKey = defaultServingKeyForRole(roleKey);
    return Math.max(1, toNumber(servings[servingKey], 1));
  }

  function suggestedQuantityForProduct(drinksCovered, product, roleKey, config) {
    return ceilToPack(drinksCovered, servingSizeForProduct(product, roleKey, config));
  }

  function splitByWeights(total, weights) {
    var keys = Object.keys(weights || {});
    var cleanWeights = {};
    var totalWeight = 0;
    var allocations = {};
    var remainders = [];
    var assigned = 0;

    keys.forEach(function(key) {
      var weight = Math.max(0, toNumber(weights[key], 0));
      cleanWeights[key] = weight;
      totalWeight += weight;
    });

    if (!keys.length || total <= 0) {
      return allocations;
    }

    if (totalWeight <= 0) {
      keys.forEach(function(key) {
        cleanWeights[key] = 1;
      });
      totalWeight = keys.length;
    }

    keys.forEach(function(key) {
      var exact = (total * cleanWeights[key]) / totalWeight;
      var base = Math.floor(exact);
      allocations[key] = base;
      assigned += base;
      remainders.push({
        key: key,
        remainder: exact - base
      });
    });

    remainders.sort(function(a, b) {
      return b.remainder - a.remainder;
    });

    for (var i = 0; i < total - assigned; i += 1) {
      allocations[remainders[i % remainders.length].key] += 1;
    }

    return allocations;
  }

  function calculatePlan(state, config) {
    var assumptions = config.assumptions || {};
    var servings = assumptions.servings || {};
    var levels = assumptions.drinkingLevels || {};
    var buffers = assumptions.bufferPresets || {};
    var mixes = assumptions.mixPresets || {};
    var spiritPresets = assumptions.spiritPresets || {};

    var totalGuests = clamp(toInt(state.totalGuests, config.defaults.totalGuests || 120), 1, 2000);
    var drinkersInput = String(state.drinkers || '').trim();
    var inferredDrinkers = drinkersInput === '';
    var effectiveDrinkers = inferredDrinkers
      ? Math.round(totalGuests * toNumber(assumptions.defaultDrinkerRatio, 0.78))
      : toInt(drinkersInput, totalGuests);
    effectiveDrinkers = clamp(effectiveDrinkers, 0, totalGuests);

    var hours = clamp(toNumber(state.hours, config.defaults.hours || 5), 1, 14);
    var level = levels[state.drinkingLevel] ? state.drinkingLevel : 'moderate';
    var levelConfig = levels[level] || { firstHour: 1.5, additionalHour: 0.9 };
    var drinksPerDrinker = toNumber(levelConfig.firstHour, 1.5) + Math.max(0, hours - 1) * toNumber(levelConfig.additionalHour, 0.9);
    var buffer = buffers[state.bufferPreset] != null ? state.bufferPreset : 'recommended';
    var bufferRatio = toNumber(buffers[buffer], 0.12);
    var totalAlcoholicDrinks = Math.ceil(effectiveDrinkers * drinksPerDrinker * (1 + bufferRatio));

    var sparklingServings = clamp(
      Math.ceil(effectiveDrinkers * toNumber(assumptions.sparklingToastShare, 0.7)),
      0,
      totalAlcoholicDrinks
    );
    var cocktailCount = clamp(toInt(state.cocktailCount, config.defaults.cocktailCount || 0), 0, totalAlcoholicDrinks);
    // Allow manual mix percentages (checkbox + percent inputs) to override presets
    var manualCats = ['Beer','Wine','Spirits','Coolers','RTD'];
    var manualWeights = {};
    var manualTotal = 0;
    manualCats.forEach(function(cat) {
      var key = 'mix' + cat;
      var enabledKey = key + 'Enabled';
      var enabled = state[enabledKey] === true || (state[key] != null && String(state[key]).trim() !== '');
      var val = toNumber(state[key], 0);
      if (enabled && val > 0) {
        var prop = cat === 'RTD' ? 'rtd' : (cat === 'Spirits' ? 'spirits' : cat.toLowerCase());
        manualWeights[prop] = val;
        manualTotal += val;
      }
    });

    var mix = null;
    if (manualTotal > 0) {
      mix = { beer: 0, wine: 0, spirits: 0, coolers: 0, rtd: 0 };
      Object.keys(manualWeights).forEach(function(k) {
        mix[k] = manualWeights[k] / manualTotal;
      });
    } else {
      var mixKey = mixes[state.mixPreset] ? state.mixPreset : 'balanced';
      mix = mixes[mixKey] || mixes.balanced || { beer: 0.32, wine: 0.28, spirits: 0.2, coolers: 0.1, rtd: 0.1 };
    }
    var spiritPresetKey = spiritPresets[state.spiritPreset] ? state.spiritPreset : 'balanced';
    var spiritWeights = spiritPresets[spiritPresetKey] || spiritPresets.balanced || { vodka: 0.28, rum: 0.2, gin: 0.16, whisky: 0.24, tequila: 0.12 };

    var remaining = Math.max(0, totalAlcoholicDrinks - sparklingServings);
    var signatureCocktails = Math.min(cocktailCount, remaining);
    var discretionary = Math.max(0, remaining - signatureCocktails);

    var beerDrinks = Math.round(discretionary * toNumber(mix.beer, 0.35));
    var wineDrinks = Math.round(discretionary * toNumber(mix.wine, 0.28));
    var coolerDrinks = Math.round(discretionary * toNumber(mix.coolers, 0.1));
    var rtdDrinks = Math.round(discretionary * toNumber(mix.rtd, 0.15));
    var spiritDrinks = Math.max(0, discretionary - beerDrinks - wineDrinks - coolerDrinks - rtdDrinks) + signatureCocktails;
    var spiritSplit = splitByWeights(spiritDrinks, spiritWeights);

    var redWineShare = clamp(toInt(state.redWineShare, config.defaults.redWineShare || 50), 0, 100);
    var redWineDrinks = Math.round(wineDrinks * (redWineShare / 100));
    var whiteWineDrinks = Math.max(0, wineDrinks - redWineDrinks);

    var naRatio = clamp(toNumber(state.nonAlcoholicRatio, config.defaults.nonAlcoholicRatio || 1.2), 0, 10);
    var nonAlcoholicServings = Math.ceil(totalGuests * naRatio * (1 + Math.max(0, hours - 4) * 0.08));

    var totalBeerCases = ceilToPack(beerDrinks, servings.beerCase || 24);
    var houseBeerCases = 0;
    var premiumBeerCases = 0;

    if (state.beerPreference === 'premium') {
      premiumBeerCases = totalBeerCases;
    } else if (state.beerPreference === 'mixed') {
      premiumBeerCases = Math.round(totalBeerCases * 0.35);
      houseBeerCases = Math.max(0, totalBeerCases - premiumBeerCases);
    } else {
      houseBeerCases = totalBeerCases;
    }

    return {
      state: {
        totalGuests: totalGuests,
        drinkers: inferredDrinkers ? '' : effectiveDrinkers,
        effectiveDrinkers: effectiveDrinkers,
        inferredDrinkers: inferredDrinkers,
        hours: hours,
        drinkingLevel: level,
        mixPreset: mixKey,
        spiritPreset: spiritPresetKey,
        cocktailCount: cocktailCount,
        redWineShare: redWineShare,
        beerPreference: state.beerPreference || 'mixed',
        nonAlcoholicRatio: naRatio,
        bufferPreset: buffer
      },
      totals: {
        alcoholicDrinks: totalAlcoholicDrinks,
        nonAlcoholicServings: nonAlcoholicServings,
        beerDrinks: beerDrinks,
        redWineDrinks: redWineDrinks,
        whiteWineDrinks: whiteWineDrinks,
        sparklingServings: sparklingServings,
        spiritDrinks: spiritDrinks,
        vodkaDrinks: spiritSplit.vodka || 0,
        rumDrinks: spiritSplit.rum || 0,
        ginDrinks: spiritSplit.gin || 0,
        whiskyDrinks: spiritSplit.whisky || 0,
        tequilaDrinks: spiritSplit.tequila || 0,
        coolerDrinks: coolerDrinks,
        rtdDrinks: rtdDrinks,
        signatureCocktails: signatureCocktails
      },
      packages: {
        houseBeerCases: houseBeerCases,
        premiumBeerCases: premiumBeerCases,
        redWineBottles: ceilToPack(redWineDrinks, servings.wineBottle || 5),
        whiteWineBottles: ceilToPack(whiteWineDrinks, servings.wineBottle || 5),
        sparklingBottles: ceilToPack(sparklingServings, servings.sparklingBottle || 6),
        vodkaBottles: ceilToPack(spiritSplit.vodka || 0, servings.spiritBottle || 17),
        rumBottles: ceilToPack(spiritSplit.rum || 0, servings.spiritBottle || 17),
        ginBottles: ceilToPack(spiritSplit.gin || 0, servings.spiritBottle || 17),
        whiskyBottles: ceilToPack(spiritSplit.whisky || 0, servings.spiritBottle || 17),
        tequilaBottles: ceilToPack(spiritSplit.tequila || 0, servings.spiritBottle || 17),
        coolerPacks: ceilToPack(coolerDrinks, servings.coolerPack || 6),
        rtdPacks: ceilToPack(rtdDrinks, servings.rtdPack || 12),
        mixerPacks: ceilToPack(spiritDrinks * toNumber(assumptions.mixerPerSpiritDrink, 0.65), servings.mixerPack || 12),
        nonAlcoholicPacks: ceilToPack(nonAlcoholicServings, servings.nonAlcoholicPack || 12)
      },
      confidence: clamp(Math.round(((effectiveDrinkers / totalGuests) * 40) + (hours * 4) + (bufferRatio * 100)), 20, 100)
    };
  }

  function buildRecommendations(plan, config) {
    var list = [];
    var priceRange = { min: 0, max: 0 };

    function push(roleKey, quantity, unitLabel, note, drinksCovered) {
      if (!quantity || quantity <= 0) return;
      var roleConfig = config.roles[roleKey];
      if (!roleConfig) return;
      var choice = chooseCandidate(roleConfig);
      var suggestedQuantity = choice.selected
        ? suggestedQuantityForProduct(drinksCovered, choice.selected, roleKey, config)
        : quantity;

      list.push({
        roleKey: roleKey,
        roleLabel: roleConfig.label || roleKey,
        quantity: suggestedQuantity,
        unitLabel: unitLabel,
        note: note,
        drinksCovered: drinksCovered,
        product: choice.selected || null,
        choices: choice.choices || [],
        minPrice: choice.minPrice || (choice.selected ? choice.selected.priceCents : 0) || 0,
        maxPrice: choice.maxPrice || (choice.selected ? choice.selected.priceCents : 0) || 0,
        usedFallback: choice.usedFallback
      });

      if (choice.selected) {
        priceRange.min += (choice.minPrice || choice.selected.priceCents || 0) * suggestedQuantity;
        priceRange.max += (choice.maxPrice || choice.selected.priceCents || 0) * suggestedQuantity;
      }
    }

    push('houseBeer', plan.packages.houseBeerCases, 'cases', 'Built from the approachable share of the beer plan.', plan.totals.beerDrinks);
    push('premiumBeer', plan.packages.premiumBeerCases, 'cases', 'Covers the premium-leaning share of the beer plan.', plan.totals.beerDrinks);
    push('redWine', plan.packages.redWineBottles, 'bottles', 'Red wine split follows the planner slider.', plan.totals.redWineDrinks);
    push('whiteWine', plan.packages.whiteWineBottles, 'bottles', 'White wine covers the remainder of the wine allocation.', plan.totals.whiteWineDrinks);
    push('sparkling', plan.packages.sparklingBottles, 'bottles', 'Sparkling supports the toast share of the event.', plan.totals.sparklingServings);
    push('vodka', plan.packages.vodkaBottles, 'bottles', 'Vodka covers its share of the spirit plan.', plan.totals.vodkaDrinks);
    push('rum', plan.packages.rumBottles, 'bottles', 'Rum covers its share of the spirit plan.', plan.totals.rumDrinks);
    push('gin', plan.packages.ginBottles, 'bottles', 'Gin covers its share of the spirit plan.', plan.totals.ginDrinks);
    push('whisky', plan.packages.whiskyBottles, 'bottles', 'Whisky covers its share of the spirit plan.', plan.totals.whiskyDrinks);
    push('tequila', plan.packages.tequilaBottles, 'bottles', 'Tequila covers its share of the spirit plan.', plan.totals.tequilaDrinks);
    push('cooler', plan.packages.coolerPacks, 'packs', 'Coolers cover the ready-to-serve canned portion of the bar.', plan.totals.coolerDrinks);
    push('rtd', plan.packages.rtdPacks, 'packs', 'Ready-to-drink products help with lighter cocktail service.', plan.totals.rtdDrinks);
    push('mixer', plan.packages.mixerPacks, 'packs', 'Mixer volume tracks the spirit recommendation.', Math.round(plan.totals.spiritDrinks * toNumber(config.assumptions.mixerPerSpiritDrink, 0.65)));
    push('nonAlcoholic', plan.packages.nonAlcoholicPacks, 'packs', 'Water, pop, and NA drinks are kept separate from the alcohol estimate.', plan.totals.nonAlcoholicServings);

    return {
      items: list,
      priceRange: priceRange
    };
  }

  function renderProductChoice(item, product, usedFallback, formatMoney) {
    if (!product) {
      return {
        thumb: '<div class="liq-planner__thumb-fallback">' + escapeHtml((item.roleLabel || 'P').charAt(0)) + '</div>',
        badge: item.manual ? 'Manual row' : 'Search catalog',
        meta: '',
        status: 'Search the catalog to select a product.',
        statusClass: '',
        priceHtml: '<strong>-</strong>'
      };
    }

    var compare = Number(product.compareAtCents || 0) > Number(product.priceCents || 0)
      ? '<span>' + escapeHtml(formatMoney(Number(product.compareAtCents || 0))) + '</span>'
      : '';
    var thumb = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" loading="lazy">'
      : '<div class="liq-planner__thumb-fallback">' + escapeHtml(item.roleLabel.charAt(0)) + '</div>';

    return {
      thumb: thumb,
      badge: usedFallback ? 'Fallback pick' : 'Curated pick',
      meta: meta,
      status: product.available ? 'Available for quick order' : 'Currently unavailable',
      statusClass: product.available ? 'is-available' : 'is-unavailable',
      priceHtml: '<strong>' + escapeHtml(formatMoney(Number(product.priceCents || 0))) + '</strong>' + compare
    };
  }

  function renderRow(item, formatMoney) {
    var product = item.product;
    var choiceView = renderProductChoice(item, product, item.usedFallback, formatMoney);
    var options = (item.choices || []).map(function(choice) {
      return '<button type="button" class="liq-planner__search-option" data-row-product-option="' + escapeHtml(choice.product.variantId) + '" data-search-label="' + escapeHtml((choice.product.title || '').toLowerCase()) + '">' + escapeHtml(choice.product.title) + (choice.product.available ? '' : ' (Unavailable)') + '</button>';
    }).join('');
    var searchValue = product ? product.title : '';

    return [
      '<article class="liq-planner__row" data-product-card data-recommendation-row data-role-key="' + escapeHtml(item.roleKey) + '" data-unit-label="' + escapeHtml(item.unitLabel || 'units') + '" data-drinks-covered="' + escapeHtml(item.drinksCovered || 0) + '" data-available="' + escapeHtml(product ? product.inventoryQuantity : 0) + '" data-policy="' + escapeHtml(product ? (product.inventoryPolicy || 'deny') : 'deny') + '" data-tags="' + escapeHtml(product ? ((product.tags || []).join('|')) : '') + '" data-price-cents="' + escapeHtml(product ? (product.priceCents || 0) : 0) + '" data-products="' + escapeHtml(JSON.stringify(item.choices || [])) + '">',
      '  <div class="liq-planner__row-top">',
      '    <div class="liq-planner__thumb-row">',
      '      <label class="liq-planner__select"><input type="checkbox" data-row-select checked' + (product && product.available ? '' : (product ? ' disabled' : '')) + '></label>',
      '      <div class="liq-planner__thumb" data-row-thumb>' + choiceView.thumb + '</div>',
      '      <div>',
      '        <div class="liq-planner__row-head">',
      '          <div><div class="liq-planner__role">' + escapeHtml(item.roleLabel) + '</div><h3 data-row-title>' + escapeHtml(product ? product.title : 'Select a product') + '</h3></div>',
      '          <span class="liq-planner__pill" data-row-badge>' + escapeHtml(choiceView.badge) + '</span>',
      '        </div>',
      '        <label class="liq-planner__alternate"><span>' + escapeHtml(item.manual ? 'Search catalog' : 'Search another product') + '</span><input type="search" value="' + escapeHtml(searchValue) + '" data-row-search placeholder="Search entire catalog"><input type="hidden" value="' + escapeHtml(product ? product.variantId : '') + '" data-row-product><div class="liq-planner__search-results" data-row-results>' + options + '</div></label>',
      '        <div class="liq-planner__copy">' + escapeHtml(item.note) + '</div>',
        '        <div class="liq-planner__copy" data-row-suggestion>Suggested quantity: ' + escapeHtml(item.quantity) + ' ' + escapeHtml(item.unitLabel) + ' for about ' + escapeHtml(item.drinksCovered) + ' servings.</div>',
      '        <div class="liq-planner__status ' + escapeHtml(choiceView.statusClass) + '" data-row-status>' + escapeHtml(choiceView.status) + '</div>',
      '      </div>',
      '    </div>',
      '  </div>',
      '  <div class="liq-planner__row-actions">',
      '    <div class="liq-planner__price" data-row-price>' + choiceView.priceHtml + '</div>',
      '    <div class="liq-planner__qty">',
      '      <button type="button" data-qty-change="-1" aria-label="Decrease quantity">-</button>',
      '      <input type="number" min="1" step="1" value="' + escapeHtml(item.quantity) + '" data-row-qty' + (product && product.available ? '' : (product ? ' disabled' : '')) + '>',
      '      <button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>',
      '    </div>',
      '    <form method="post" action="/cart/add" class="new-product-form liq-planner__form-row">',
      '      <input type="hidden" name="id" value="' + escapeHtml(product ? product.variantId : '') + '" data-row-variant-id>',
      '      <input type="hidden" name="quantity" value="' + escapeHtml(item.quantity) + '" data-row-qty-hidden>',
      '      <button type="submit"' + (product && product.available ? '' : ' disabled') + '>Add item</button>',
      '    </form>',
      '  </div>',
      '</article>'
    ].join('');
  }

  function initPlanner(section) {
    if (!section || section.dataset.plannerReady === 'true') return;

    var configNode = section.querySelector('[data-wedding-planner-config]');
    if (!configNode) return;

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      console.error('Wedding planner config parse failed', error);
      return;
    }

    var formatter = moneyFormatter(config.labels && config.labels.currencyCode);
    var formatMoney = function(cents) {
      return formatter.format((Number(cents || 0)) / 100);
    };

    var inputs = {};
    section.querySelectorAll('[data-planner-input]').forEach(function(input) {
      inputs[input.getAttribute('data-planner-input')] = input;
    });

    var outputs = {};
    section.querySelectorAll('[data-planner-output]').forEach(function(node) {
      outputs[node.getAttribute('data-planner-output')] = node;
    });

    var storageKey = 'wedding-planner:' + (section.dataset.sectionId || 'default');
    var savedState = {};
    try {
      savedState = JSON.parse(window.localStorage.getItem(storageKey) || '{}') || {};
    } catch (error) {
      savedState = {};
    }

    var state = Object.assign({}, config.defaults || {}, savedState.inputs || {});
    var addSelectedButton = section.querySelector('[data-planner-action="add-selected"]');
    var tabButtons = Array.prototype.slice.call(section.querySelectorAll('[data-planner-tab]'));
    var tabPanels = Array.prototype.slice.call(section.querySelectorAll('[data-planner-panel]'));
    var tabState = savedState.tab || 'details';
    var rowState = savedState.rows || {};
    var manualRows = savedState.manualRows || [];
    var remoteSearchCache = {};
    var rowChoices = {};
    var searchDebounceTimers = {};

    function persistState() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify({
          inputs: state,
          tab: tabState,
          rows: rowState,
          manualRows: manualRows
        }));
      } catch (error) {
      }
    }

    function setActiveTab(tab) {
      tabState = tab;
      tabButtons.forEach(function(button) {
        var isActive = button.getAttribute('data-planner-tab') === tab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      tabPanels.forEach(function(panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-planner-panel') === tab);
      });
      persistState();
    }

    function collectState() {
      Object.keys(inputs).forEach(function(key) {
        try {
          var el = inputs[key];
          if (!el) return;
          if (el.type === 'checkbox') {
            state[key] = !!el.checked;
          } else {
            state[key] = el.value;
          }
        } catch (e) {
        }
      });
      persistState();
    }

    function syncInputs(planState) {
      Object.keys(inputs).forEach(function(key) {
        if (planState[key] != null) {
          try {
            var el = inputs[key];
            if (!el) return;
            if (el.type === 'checkbox') {
              el.checked = !!planState[key];
            } else {
              el.value = planState[key];
            }
          } catch (e) {
          }
        }
      });
    }

    function updateSelectionSummary() {
      var rows = Array.prototype.slice.call(section.querySelectorAll('[data-recommendation-row]'));
      var selectedCount = 0;
      var selectedSpend = 0;

      rows.forEach(function(row) {
        var roleKey = row.getAttribute('data-role-key');
        var checkbox = row.querySelector('[data-row-select]');
        var qtyInput = row.querySelector('[data-row-qty]');
        var qtyHidden = row.querySelector('[data-row-qty-hidden]');
        var productSelect = row.querySelector('[data-row-product]');
        var qty = clamp(toInt(qtyInput && qtyInput.value, 1), 1, 999);

        if (qtyInput) qtyInput.value = qty;
        if (qtyHidden) qtyHidden.value = qty;
        if (roleKey) {
          rowState[roleKey] = {
            selected: !!(checkbox && checkbox.checked),
            quantity: qty,
            variantId: productSelect ? productSelect.value : null,
            quantityLocked: document.activeElement === qtyInput || !!row.getAttribute('data-quantity-locked')
          };
          if (String(roleKey).indexOf('manual-') === 0) {
            manualRows = manualRows.map(function(item) {
              return item.id === roleKey ? Object.assign({}, item, { quantity: qty }) : item;
            });
          }
        }

        if (checkbox && checkbox.checked) {
          selectedCount += 1;
          selectedSpend += qty * toNumber(row.getAttribute('data-price-cents'), 0);
        }
      });

      if (outputs.selectionCount) {
        outputs.selectionCount.textContent = selectedCount + (selectedCount === 1 ? ' item selected' : ' items selected');
      }
      if (outputs.selectedSpend) {
        outputs.selectedSpend.textContent = formatMoney(selectedSpend);
      }
      if (outputs.selectionFootnote && config.labels && config.labels.selectionFootnote) {
        outputs.selectionFootnote.textContent = config.labels.selectionFootnote;
      }
      if (addSelectedButton) {
        addSelectedButton.disabled = selectedCount === 0;
      }
      persistState();
    }

    function applySavedRowState() {
      Array.prototype.slice.call(section.querySelectorAll('[data-recommendation-row]')).forEach(function(row) {
        var roleKey = row.getAttribute('data-role-key');
        var savedRow = roleKey ? rowState[roleKey] : null;
        var checkbox = row.querySelector('[data-row-select]');
        var qtyInput = row.querySelector('[data-row-qty]');
        var productSelect = row.querySelector('[data-row-product]');
        if (!savedRow) return;
        if (productSelect && savedRow.variantId) {
          productSelect.value = String(savedRow.variantId);
          syncRowProduct(row);
        }
        if (checkbox && !checkbox.disabled && typeof savedRow.selected === 'boolean') {
          checkbox.checked = savedRow.selected;
        }
        if (qtyInput && !qtyInput.disabled && savedRow.quantity != null) {
          qtyInput.value = clamp(toInt(savedRow.quantity, 1), 1, 999);
        }
      });
    }

    function seedEmptyRows(recommendationModel) {
      recommendationModel.items.forEach(function(item) {
        rowChoices[item.roleKey] = item.choices || [];
        if (!rowState[item.roleKey]) {
          rowState[item.roleKey] = {
            selected: true,
            quantity: item.quantity,
            variantId: item.product ? item.product.variantId : null,
            quantityLocked: false
          };
        }
      });
    }

    function buildManualItems() {
      return manualRows.map(function(row) {
        rowChoices[row.id] = row.choices || [];
        return {
          roleKey: row.id,
          roleLabel: row.label || 'Extra product',
          quantity: row.quantity || 1,
          unitLabel: row.unitLabel || 'units',
          note: row.note || 'Use this row to add an extra catalog product beyond the generated recommendations.',
          drinksCovered: row.drinksCovered || 0,
          product: row.product || null,
          choices: row.choices || [],
          usedFallback: true,
          manual: true
        };
      });
    }

    function syncRowProduct(row) {
      var roleKey = row.getAttribute('data-role-key');
      var serialized = row.getAttribute('data-products');
      var select = row.querySelector('[data-row-product]');
      var variantInput = row.querySelector('[data-row-variant-id]');
      var submitButton = row.querySelector('.liq-planner__form-row button');
      var checkbox = row.querySelector('[data-row-select]');
      var qtyInput = row.querySelector('[data-row-qty]');
      if (!select) return;

      try {
        var products = rowChoices[roleKey];
        if (!products) {
          products = serialized ? JSON.parse(serialized) : [];
          rowChoices[roleKey] = products;
        }
        var selected = products.find(function(choice) {
          return String(choice.product.variantId) === String(select.value);
        }) || products[0];
        if (!selected) return;
        var savedRow = roleKey ? rowState[roleKey] : null;
        var drinksCovered = toNumber(row.getAttribute('data-drinks-covered'), 0);
        var suggestedQty = suggestedQuantityForProduct(drinksCovered, selected.product, roleKey, config);

        var view = renderProductChoice({
          roleKey: roleKey,
          roleLabel: row.querySelector('.liq-planner__role') ? row.querySelector('.liq-planner__role').textContent : ''
        }, selected.product, selected.usedFallback, formatMoney);

        row.setAttribute('data-price-cents', selected.product.priceCents || 0);
        row.setAttribute('data-available', selected.product.inventoryQuantity || 0);
        row.setAttribute('data-policy', selected.product.inventoryPolicy || 'deny');
        row.setAttribute('data-tags', (selected.product.tags || []).join('|'));

        if (variantInput) variantInput.value = selected.product.variantId;
        if (row.querySelector('[data-row-title]')) row.querySelector('[data-row-title]').textContent = selected.product.title;
        if (row.querySelector('[data-row-badge]')) row.querySelector('[data-row-badge]').textContent = view.badge;
        if (row.querySelector('[data-row-thumb]')) row.querySelector('[data-row-thumb]').innerHTML = view.thumb;
        if (row.querySelector('[data-row-search]')) row.querySelector('[data-row-search]').value = selected.product.title;
        if (row.querySelector('[data-row-status]')) {
          row.querySelector('[data-row-status]').textContent = view.status;
          row.querySelector('[data-row-status]').className = 'liq-planner__status ' + view.statusClass;
        }
        if (row.querySelector('[data-row-price]')) row.querySelector('[data-row-price]').innerHTML = view.priceHtml;
        if (row.querySelector('[data-row-suggestion]')) {
          row.querySelector('[data-row-suggestion]').textContent = 'Suggested quantity: ' + suggestedQty + ' ' + (row.getAttribute('data-unit-label') || 'units') + ' for about ' + drinksCovered + ' servings.';
        }

        if (qtyInput && !(savedRow && savedRow.quantityLocked)) {
          qtyInput.value = clamp(toInt(suggestedQty, 1), 1, 999);
        }

        var disabled = !selected.product.available;
        if (qtyInput) qtyInput.disabled = disabled;
        if (submitButton) submitButton.disabled = disabled;
        if (checkbox) {
          checkbox.disabled = disabled;
          if (disabled) checkbox.checked = false;
        }

        if (String(roleKey).indexOf('manual-') === 0) {
          manualRows = manualRows.map(function(item) {
            if (item.id !== roleKey) return item;
            return Object.assign({}, item, {
              product: selected.product,
              choices: rowChoices[roleKey] || [],
              quantity: qtyInput ? clamp(toInt(qtyInput.value, 1), 1, 999) : 1
            });
          });
          persistState();
        }
      } catch (error) {
      }
    }

    function renderSearchResults(row, choices) {
      var results = row.querySelector('[data-row-results]');
      if (!results) return;
      results.innerHTML = (choices || []).map(function(choice) {
        return '<button type="button" class="liq-planner__search-option" data-row-product-option="' + escapeHtml(choice.product.variantId) + '" data-search-label="' + escapeHtml((choice.product.title || '').toLowerCase()) + '">' + escapeHtml(choice.product.title) + (choice.product.available ? '' : ' (Unavailable)') + '</button>';
      }).join('');
    }

    function normalizeRemoteProduct(product) {
      if (!product) return null;
      var variant = product.variants && product.variants.length ? product.variants.find(function(item) { return item.available; }) || product.variants[0] : null;
      if (!variant) return null;
      return {
        id: product.id,
        handle: product.handle,
        variantId: variant.id,
        title: product.title,
        vendor: product.vendor || '',
        type: product.type || product.product_type || '',
        url: product.url || ('/products/' + product.handle),
        available: !!variant.available,
        inventoryQuantity: variant.inventory_quantity != null ? variant.inventory_quantity : 0,
        inventoryPolicy: variant.inventory_policy || 'deny',
        priceCents: variant.price || 0,
        compareAtCents: variant.compare_at_price || 0,
        tags: product.tags || [],
        plannerServings: '',
        packSize: '',
        containerMl: '',
        size: '',
        volume: '',
        abv: '',
        image: product.featured_image || (product.image ? product.image : null),
        imageAlt: product.title
      };
    }

    function parsePlannerSearchResponse(markup) {
      var parser = new window.DOMParser();
      var doc = parser.parseFromString(markup, 'text/html');
      var jsonNode = doc.querySelector('[data-planner-search-results]');
      if (!jsonNode) return [];

      try {
        var payload = JSON.parse(jsonNode.textContent || '{}');
        return payload && Array.isArray(payload.products) ? payload.products.filter(Boolean) : [];
      } catch (error) {
        return [];
      }
    }

    function searchCatalog(term) {
      var key = normalizeText(term);
      if (!key) {
        return Promise.resolve([]);
      }
      if (remoteSearchCache[key]) {
        return Promise.resolve(remoteSearchCache[key]);
      }

      var url = '/search?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last&section_id=planner-search-results';
      return window.fetch(url, {
        credentials: 'same-origin'
      }).then(function(response) {
        if (!response.ok) throw new Error('Search failed');
        return response.text();
      }).then(function(markup) {
        var products = parsePlannerSearchResponse(markup);
        remoteSearchCache[key] = products;
        return products;
      }).catch(function() {
        return [];
      });
    }

    function mergeChoices(existingChoices, remoteProducts) {
      var merged = [];
      var seen = {};

      (existingChoices || []).forEach(function(choice) {
        if (!choice || !choice.product || seen[choice.product.variantId]) return;
        seen[choice.product.variantId] = true;
        merged.push(choice);
      });

      (remoteProducts || []).forEach(function(product) {
        if (!product || seen[product.variantId]) return;
        seen[product.variantId] = true;
        merged.push({
          product: product,
          usedFallback: true
        });
      });

      return merged;
    }

    function toggleSearchResults(row, isOpen) {
      if (!row) return;
      var results = row.querySelector('[data-row-results]');
      if (!results) return;
      results.classList.toggle('is-open', !!isOpen);
    }

    function renderPlan(plan, recommendationModel) {
      var renderedItems = recommendationModel.items.concat(buildManualItems());
      syncInputs(plan.state);

      if (outputs.redWineShareLabel) outputs.redWineShareLabel.textContent = plan.state.redWineShare + '%';
      if (outputs.totalAlcoholicDrinks) outputs.totalAlcoholicDrinks.textContent = plan.totals.alcoholicDrinks;
      if (outputs.effectiveDrinkers) outputs.effectiveDrinkers.textContent = plan.state.effectiveDrinkers + (plan.state.inferredDrinkers ? ' estimated' : ' confirmed');
      if (outputs.nonAlcoholicServings) outputs.nonAlcoholicServings.textContent = plan.totals.nonAlcoholicServings;
      if (outputs.beerSummary) outputs.beerSummary.textContent = (plan.packages.houseBeerCases + plan.packages.premiumBeerCases) + ' cases';
      if (outputs.wineSummary) outputs.wineSummary.textContent = (plan.packages.redWineBottles + plan.packages.whiteWineBottles) + ' bottles';
      if (outputs.sparklingSummary) outputs.sparklingSummary.textContent = plan.packages.sparklingBottles + ' bottles';
      if (outputs.vodkaSummary) outputs.vodkaSummary.textContent = plan.packages.vodkaBottles + ' bottles';
      if (outputs.rumSummary) outputs.rumSummary.textContent = plan.packages.rumBottles + ' bottles';
      if (outputs.ginSummary) outputs.ginSummary.textContent = plan.packages.ginBottles + ' bottles';
      if (outputs.whiskySummary) outputs.whiskySummary.textContent = plan.packages.whiskyBottles + ' bottles';
      if (outputs.tequilaSummary) outputs.tequilaSummary.textContent = plan.packages.tequilaBottles + ' bottles';
      if (outputs.coolerSummary) outputs.coolerSummary.textContent = plan.packages.coolerPacks + ' packs';
      if (outputs.rtdSummary) outputs.rtdSummary.textContent = plan.packages.rtdPacks + ' packs';
      if (outputs.serviceSummary) outputs.serviceSummary.textContent = plan.packages.mixerPacks + ' mixer packs + ' + plan.packages.nonAlcoholicPacks + ' NA packs';
      if (outputs.spendRange) outputs.spendRange.textContent = formatMoney(recommendationModel.priceRange.min) + ' - ' + formatMoney(recommendationModel.priceRange.max);
      if (outputs.confidenceLabel) outputs.confidenceLabel.textContent = plan.confidence >= 80 ? 'High coverage' : (plan.confidence >= 55 ? 'Balanced' : 'Tight');
      if (outputs.confidenceFill) outputs.confidenceFill.style.width = plan.confidence + '%';

      if (outputs.notes) {
        var notes = [];
        if (plan.state.inferredDrinkers) {
          notes.push('Drinkers were estimated from the default drinker ratio because a confirmed count was not entered.');
        } else {
          notes.push('Confirmed drinker count overrides the default guest ratio.');
        }
        if (plan.totals.signatureCocktails > 0) {
          notes.push('Signature cocktails push spirits and mixers higher than a standard bar split.');
        }
        notes.push('Spirit volume is split across vodka, rum, gin, whisky, and tequila based on the selected spirit focus.');
        if (plan.packages.coolerPacks > 0) {
          notes.push('Coolers are planned separately from RTDs so you can merchandise canned cocktails and coolers independently.');
        }
        if (plan.packages.sparklingBottles > 0) {
          notes.push('Sparkling bottles assume a toast for roughly ' + Math.round(toNumber(config.assumptions.sparklingToastShare, 0.7) * 100) + '% of drinkers.');
        }
        outputs.notes.innerHTML = notes.map(function(note) {
          return '<li>' + escapeHtml(note) + '</li>';
        }).join('');
      }

      if (outputs.recommendations) {
        outputs.recommendations.innerHTML = renderedItems.map(function(item) {
          return renderRow(item, formatMoney);
        }).join('');
      }
      if (outputs.emptyState) {
        outputs.emptyState.classList.toggle('liq-planner__hidden', renderedItems.length > 0);
      }

      if (typeof window.initCartForms === 'function') {
        try {
          window.initCartForms('[data-section-id="' + section.dataset.sectionId + '"] .new-product-form');
        } catch (error) {
          console.warn('Wedding planner form init failed', error);
        }
      }

      seedEmptyRows(recommendationModel);
      applySavedRowState();
      updateSelectionSummary();
      renderPrintSummary(plan);
    }

    function renderPrintSummary(plan) {
      if (!outputs.printSummary) return;
      var rows = Array.prototype.slice.call(section.querySelectorAll('[data-recommendation-row]')).filter(function(row) {
        var checkbox = row.querySelector('[data-row-select]');
        var variantInput = row.querySelector('[data-row-variant-id]');
        return checkbox && checkbox.checked && variantInput && variantInput.value;
      });
      var rowByRole = {};
      rows.forEach(function(row) {
        var roleKey = row.getAttribute('data-role-key') || '';
        rowByRole[roleKey] = {
          title: row.querySelector('[data-row-title]') ? row.querySelector('[data-row-title]').textContent : 'Product',
          qty: row.querySelector('[data-row-qty]') ? row.querySelector('[data-row-qty]').value : '1'
        };
      });

      function packageLine(label, value, roleKeys) {
        var roles = Array.isArray(roleKeys) ? roleKeys : [roleKeys];
        var matches = roles.map(function(roleKey) {
          return rowByRole[roleKey];
        }).filter(Boolean);
        return {
          label: label,
          value: value,
          detail: matches.map(function(match) {
            return match.title + ' x ' + match.qty;
          }).join(' | ')
        };
      }

      var packageSummary = [
        packageLine('Beer', ((plan.packages.houseBeerCases + plan.packages.premiumBeerCases) || 0) + ' cases', ['houseBeer', 'premiumBeer']),
        packageLine('Wine', ((plan.packages.redWineBottles + plan.packages.whiteWineBottles) || 0) + ' bottles', ['redWine', 'whiteWine']),
        packageLine('Sparkling', (plan.packages.sparklingBottles || 0) + ' bottles', 'sparkling'),
        packageLine('Vodka', (plan.packages.vodkaBottles || 0) + ' bottles', 'vodka'),
        packageLine('Rum', (plan.packages.rumBottles || 0) + ' bottles', 'rum'),
        packageLine('Gin', (plan.packages.ginBottles || 0) + ' bottles', 'gin'),
        packageLine('Whisky', (plan.packages.whiskyBottles || 0) + ' bottles', 'whisky'),
        packageLine('Tequila', (plan.packages.tequilaBottles || 0) + ' bottles', 'tequila'),
        packageLine('Coolers', (plan.packages.coolerPacks || 0) + ' packs', 'cooler'),
        packageLine('RTD', (plan.packages.rtdPacks || 0) + ' packs', 'rtd'),
        packageLine('Mixers', (plan.packages.mixerPacks || 0) + ' packs', 'mixer'),
        packageLine('Non-alcoholic', (plan.packages.nonAlcoholicPacks || 0) + ' packs', 'nonAlcoholic')
      ];

      manualRows.forEach(function(row) {
        if (!row || !row.product) return;
        packageSummary.push({
          label: row.label || 'Extra product',
          value: (row.quantity || 1) + ' units',
          detail: row.product.title + ' x ' + (row.quantity || 1)
        });
      });

      var printOutputs = {};
      outputs.printSummary.querySelectorAll('[data-print-output]').forEach(function(node) {
        printOutputs[node.getAttribute('data-print-output')] = node;
      });
      var store = config.labels || {};
      var today = new Date();
      var formattedDate = today.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      var invoiceNumber = 'EVT-' + today.getFullYear() + String(today.getMonth() + 1).padStart(2, '0') + String(today.getDate()).padStart(2, '0');

      outputs.printSummary.innerHTML = [
        '<div class="liq-planner__invoice">',
        '  <div class="liq-planner__invoice-top">',
        '    <div class="liq-planner__invoice-brand">',
              store.storeLogo ? '      <img src="' + escapeHtml(store.storeLogo) + '" alt="' + escapeHtml(store.storeName || 'Store logo') + '" class="liq-planner__invoice-logo">' : '',
        '      <div>',
        '        <h3>' + escapeHtml(store.storeName || 'Store summary') + '</h3>',
        '        <p>' + escapeHtml(store.storeAddress || '') + '</p>',
        '        <p>' + escapeHtml([store.storePhone, store.storeEmail].filter(Boolean).join(' | ')) + '</p>',
        '      </div>',
        '    </div>',
        '    <div class="liq-planner__invoice-meta">',
        '      <div><span>Document</span><strong>Event Planning Summary</strong></div>',
        '      <div><span>Reference</span><strong>' + escapeHtml(invoiceNumber) + '</strong></div>',
        '      <div><span>Date</span><strong>' + escapeHtml(formattedDate) + '</strong></div>',
        '    </div>',
        '  </div>',
        '  <div class="liq-planner__invoice-blocks">',
        '    <div class="liq-planner__invoice-block">',
        '      <h4>Event details</h4>',
        '      <p><strong>' + escapeHtml(state.eventName || 'Event summary') + '</strong></p>',
        '      <p>' + escapeHtml(state.eventAddress || '') + '</p>',
        '    </div>',
        '    <div class="liq-planner__invoice-block">',
        '      <h4>Contact</h4>',
        '      <p>' + escapeHtml(state.contactName || '') + '</p>',
        '      <p>' + escapeHtml(state.contactInfo || '') + '</p>',
        '    </div>',
        '  </div>',
        '  <div class="liq-planner__invoice-grid">',
        '    <div><strong>Guests</strong><span>' + escapeHtml(String(plan.state.totalGuests || 0)) + '</span></div>',
        '    <div><strong>Drinkers</strong><span>' + escapeHtml(String(plan.state.effectiveDrinkers || 0)) + '</span></div>',
        '    <div><strong>Hours</strong><span>' + escapeHtml(String(plan.state.hours || 0)) + '</span></div>',
        '    <div><strong>Alcoholic drinks</strong><span>' + escapeHtml(String(plan.totals.alcoholicDrinks || 0)) + '</span></div>',
        '  </div>',
        '  <div class="liq-planner__invoice-section">',
        '    <h4>Package summary</h4>',
        '    <div>' + packageSummary.map(function(line) {
              return '<div class="liq-planner__print-list-row"><div><span>' + escapeHtml(line.label) + '</span>' + (line.detail ? '<p>' + escapeHtml(line.detail) + '</p>' : '') + '</div><strong>' + escapeHtml(line.value) + '</strong></div>';
            }).join('') + '</div>',
        '  </div>',
        '</div>'
      ].join('');

      outputs.printSummary.querySelectorAll('[data-print-output]').forEach(function(node) {
        printOutputs[node.getAttribute('data-print-output')] = node;
      });

      if (printOutputs.guestCount) printOutputs.guestCount.textContent = String(plan.state.totalGuests || 0);
      if (printOutputs.drinkerCount) printOutputs.drinkerCount.textContent = String(plan.state.effectiveDrinkers || 0);
      if (printOutputs.hours) printOutputs.hours.textContent = String(plan.state.hours || 0);
      if (printOutputs.alcoholicDrinks) printOutputs.alcoholicDrinks.textContent = String(plan.totals.alcoholicDrinks || 0);
    }

    function printSummary() {
      if (!outputs.printSummary) return;
      var printWindow = window.open('', '_blank', 'width=900,height=700');
      if (!printWindow) return;
      printWindow.document.write('<html><head><title>Event summary</title><style>body{font-family:Arial,sans-serif;padding:28px;color:#111827}img{display:block;max-width:140px;height:auto}h3,h4{margin:0}p{margin:4px 0 0}.liq-planner__invoice{max-width:860px;margin:0 auto}.liq-planner__invoice-top{display:flex;justify-content:space-between;gap:24px;padding-bottom:18px;border-bottom:2px solid #111827}.liq-planner__invoice-brand{display:flex;gap:18px;align-items:flex-start}.liq-planner__invoice-brand h3{font-size:1.5rem;margin-bottom:6px}.liq-planner__invoice-meta{min-width:220px}.liq-planner__invoice-meta div{display:flex;justify-content:space-between;gap:16px;padding:6px 0;border-bottom:1px solid #e5e7eb}.liq-planner__invoice-meta span{color:#6b7280;font-size:.82rem;text-transform:uppercase;letter-spacing:.08em}.liq-planner__invoice-blocks{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;margin-top:22px}.liq-planner__invoice-block{border:1px solid #e5e7eb;border-radius:14px;padding:14px 16px;background:#fafafa}.liq-planner__invoice-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px;margin-top:22px}.liq-planner__invoice-grid div{border:1px solid #e5e7eb;border-radius:14px;padding:14px 16px;background:#fff}.liq-planner__invoice-grid strong,.liq-planner__invoice-block h4{display:block;margin-bottom:6px}.liq-planner__invoice-grid span{font-size:1.1rem;font-weight:700}.liq-planner__invoice-section{margin-top:24px}.liq-planner__print-list-row{display:flex;justify-content:space-between;gap:16px;padding:10px 0;border-bottom:1px solid #e5e7eb}.liq-planner__print-list-row div{max-width:70%}.liq-planner__print-list-row span{display:block;font-weight:700}.liq-planner__print-list-row p{color:#6b7280;font-size:.92rem;margin-top:4px}@media print{body{padding:0}}</style></head><body>' + outputs.printSummary.innerHTML + '</body></html>');
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }

    async function addSelected() {
      var rows = Array.prototype.slice.call(section.querySelectorAll('[data-recommendation-row]')).filter(function(row) {
        var checkbox = row.querySelector('[data-row-select]');
        var qtyInput = row.querySelector('[data-row-qty]');
        return checkbox && checkbox.checked && qtyInput && !qtyInput.disabled && toInt(qtyInput.value, 0) > 0;
      });

      if (!rows.length || typeof window.addToCartWithCheck !== 'function') return;

      addSelectedButton.disabled = true;
      addSelectedButton.textContent = 'Adding...';

      try {
        for (var i = 0; i < rows.length; i += 1) {
          var row = rows[i];
          var variantInput = row.querySelector('input[name="id"]');
          var qtyInput = row.querySelector('[data-row-qty]');
          if (!variantInput || !qtyInput) continue;
          await window.addToCartWithCheck(Number(variantInput.value), row, toInt(qtyInput.value, 1));
        }
      } finally {
        addSelectedButton.textContent = 'Add selected to cart';
        updateSelectionSummary();
      }
    }

    function refresh() {
      collectState();
      var plan = calculatePlan(state, config);
      var recommendationModel = buildRecommendations(plan, config);
      renderPlan(plan, recommendationModel);
    }

    section.addEventListener('input', function(event) {
      if (event.target.matches('[data-planner-input]')) {
        refresh();
        return;
      }
      if (event.target.matches('[data-row-search]')) {
        var term = normalizeText(event.target.value);
        var row = event.target.closest('[data-recommendation-row]');
        if (row) {
          toggleSearchResults(row, true);
          var roleKey = row.getAttribute('data-role-key');
          Array.prototype.slice.call(row.querySelectorAll('[data-row-product-option]')).forEach(function(option) {
            var label = option.getAttribute('data-search-label') || '';
            option.classList.toggle('liq-planner__hidden', term !== '' && label.indexOf(term) === -1);
          });

          if (searchDebounceTimers[roleKey]) {
            window.clearTimeout(searchDebounceTimers[roleKey]);
          }

          searchDebounceTimers[roleKey] = window.setTimeout(function() {
            searchCatalog(term).then(function(remoteProducts) {
              rowChoices[roleKey] = mergeChoices(rowChoices[roleKey], remoteProducts);
              renderSearchResults(row, rowChoices[roleKey]);
              Array.prototype.slice.call(row.querySelectorAll('[data-row-product-option]')).forEach(function(option) {
                var label = option.getAttribute('data-search-label') || '';
                option.classList.toggle('liq-planner__hidden', term !== '' && label.indexOf(term) === -1);
              });
            });
          }, 220);
        }
        return;
      }
      if (event.target.matches('[data-row-product]')) {
        syncRowProduct(event.target.closest('[data-recommendation-row]'));
        updateSelectionSummary();
        return;
      }
      if (event.target.matches('[data-row-qty], [data-row-select]')) {
        if (event.target.matches('[data-row-qty]')) {
          var qtyRow = event.target.closest('[data-recommendation-row]');
          if (qtyRow) qtyRow.setAttribute('data-quantity-locked', 'true');
        }
        updateSelectionSummary();
      }
    });

    section.addEventListener('change', function(event) {
      if (event.target.matches('[data-planner-input]')) {
        refresh();
      }
    });

    section.addEventListener('click', function(event) {
      var qtyButton = event.target.closest('[data-qty-change]');
      if (qtyButton) {
        var row = qtyButton.closest('[data-recommendation-row]');
        var shell = qtyButton.closest('.liq-planner__qty');
        var input = shell ? shell.querySelector('[data-row-qty]') : null;
        if (!input || input.disabled) return;
        if (row) row.setAttribute('data-quantity-locked', 'true');
        input.value = clamp(toInt(input.value, 1) + toInt(qtyButton.getAttribute('data-qty-change'), 0), 1, 999);
        updateSelectionSummary();
        return;
      }

      if (event.target.closest('[data-planner-action="add-selected"]')) {
        event.preventDefault();
        addSelected();
        return;
      }

      if (event.target.closest('[data-planner-action="add-manual-row"]')) {
        event.preventDefault();
        manualRows.push({
          id: 'manual-' + Date.now(),
          label: 'Extra product',
          quantity: 1,
          product: null,
          choices: [],
          note: 'Search the catalog and add any extra product you want in the order.',
          unitLabel: 'units',
          drinksCovered: 0
        });
        persistState();
        refresh();
        return;
      }

      if (event.target.closest('[data-planner-action="print-summary"]')) {
        event.preventDefault();
        printSummary();
        return;
      }

      var optionButton = event.target.closest('[data-row-product-option]');
      if (optionButton) {
        event.preventDefault();
        var optionRow = optionButton.closest('[data-recommendation-row]');
        var hiddenInput = optionRow ? optionRow.querySelector('[data-row-product]') : null;
        if (hiddenInput) {
          hiddenInput.value = optionButton.getAttribute('data-row-product-option');
          syncRowProduct(optionRow);
          toggleSearchResults(optionRow, false);
          updateSelectionSummary();
        }
        return;
      }

      var searchInput = event.target.closest('[data-row-search]');
      if (!searchInput) {
        Array.prototype.slice.call(section.querySelectorAll('[data-recommendation-row]')).forEach(function(row) {
          toggleSearchResults(row, false);
        });
      }

      var tabButton = event.target.closest('[data-planner-tab]');
      if (tabButton) {
        event.preventDefault();
        setActiveTab(tabButton.getAttribute('data-planner-tab'));
      }
    });

    section.addEventListener('focusin', function(event) {
      var row = event.target.closest('[data-recommendation-row]');
      if (event.target.matches('[data-row-search]') && row) {
        toggleSearchResults(row, true);
      }
    });

    section.addEventListener('focusout', function(event) {
      var row = event.target.closest('[data-recommendation-row]');
      if (!row) return;
      window.setTimeout(function() {
        if (!row.contains(document.activeElement)) {
          toggleSearchResults(row, false);
        }
      }, 0);
    });

    section.dataset.plannerReady = 'true';
    setActiveTab(tabState);
    refresh();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-wedding-planner]').forEach(initPlanner);
  }

  document.addEventListener('DOMContentLoaded', function() {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    boot(event.target);
  });
})();
